import type { ErrorLike } from '@apollo/client';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';

import { DEFAULT_ERROR_MESSAGE, apiDefaultErrors } from '@constants/apiErrors';

const AUTO_HIDE_MS = 5000;

const getApiErrorMessage = (message: string) => {
  if (apiDefaultErrors.some((reason) => message.includes(reason))) {
    return DEFAULT_ERROR_MESSAGE;
  }

  return message;
};

const useSnackbarError = (onClose?: () => void) => {
  const { enqueueSnackbar } = useSnackbar();
  return (error: ErrorLike) => {
    const parsedMessage = getApiErrorMessage(error.message);

    enqueueSnackbar(parsedMessage, {
      variant: 'error',
      autoHideDuration: AUTO_HIDE_MS,
      anchorOrigin: { vertical: 'top', horizontal: 'center' },
      onClose,
      preventDuplicate: true,
    });
  };
};

const useSnackbarErrors = (errors: ErrorLike[], onClose?: () => void) => {
  const { enqueueSnackbar } = useSnackbar();
  const addSnackbarError = useSnackbarError(onClose);

  useEffect(() => {
    if (errors.length) {
      errors.forEach((error) => {
        addSnackbarError(error);
      });
    }
  }, [enqueueSnackbar, errors, onClose, addSnackbarError]);
};

export { useSnackbarError, useSnackbarErrors };
